import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Title, Text, Paper } from '@mantine/core';
import Logo from '../components/Logo';

export default function PreLaunchTermsPage() {
  return (
    <div className="min-h-screen bg-[#F6F5F4]">
      <div className="py-6 px-6">
        <Link to="/">
          <Logo className="h-10 mx-auto block" />
        </Link>
      </div>

      <Container size="sm" pb={64}>
        <Title order={2} ta="center" mb="xl">
          Regulamin listy oczekujących
        </Title>

        <Paper radius="lg" p="xl" withBorder>
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <div>
              <Text fw={600} mb="xs">1. Administrator danych</Text>
              <Text size="sm" c="dimmed">
                Administratorem danych osobowych jest firma Upcode z siedzibą pod adresem
                ul. Sporna 9, 95-015 Głowno, NIP: 8341813553. Kontakt: kontakt@droid.pl.
              </Text>
            </div>

            <div>
              <Text fw={600} mb="xs">2. Cel przetwarzania</Text>
              <Text size="sm" c="dimmed">
                Podany adres email będzie przetwarzany wyłącznie w celu informowania o uruchomieniu
                serwisu Droid.pl, przekazywania ofert specjalnych dla osób z listy oczekujących
                oraz przesyłania informacji o nowościach i aktualizacjach serwisu.
              </Text>
            </div>

            <div>
              <Text fw={600} mb="xs">3. Podstawa prawna</Text>
              <Text size="sm" c="dimmed">
                Dane przetwarzane są na podstawie zgody (art. 6 ust. 1 lit. a RODO).
                Zgodę można wycofać w dowolnym momencie, wysyłając wiadomość na adres kontakt@droid.pl.
              </Text>
            </div>

            <div>
              <Text fw={600} mb="xs">4. Okres przechowywania</Text>
              <Text size="sm" c="dimmed">
                Dane będą przechowywane do momentu wycofania zgody lub do 12 miesięcy od zapisania się
                na listę oczekujących, w zależności od tego co nastąpi wcześniej.
              </Text>
            </div>

            <div>
              <Text fw={600} mb="xs">5. Prawa użytkownika</Text>
              <Text size="sm" c="dimmed">
                Przysługuje Ci prawo dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania
                oraz prawo do wycofania zgody. W celu realizacji tych praw skontaktuj się z nami: kontakt@droid.pl.
              </Text>
            </div>
          </div>
        </Paper>

        <Text size="xs" c="gray.5" ta="center" mt="xl">
          &copy; 2026 Droid.pl &middot; Upcode, ul. Sporna 9, 95-015 Głowno
        </Text>
      </Container>
    </div>
  );
}
